module.exports = __webpack_public_path__ + "static/media/114.b366990f.jpg";